import React, { Component, Fragment } from 'react'
import { Dropdown, DropdownToggle, DropdownMenu, DropdownItem } from 'reactstrap';
import { LanguageConsumer, Translate, TranslateExt } from "../contexts/LanguageContext";
import { UserService } from '../services/UserService';
import { Loading } from './index';

export class UserAccounts extends Component {

    constructor(props) {
        super(props)

        let user = JSON.parse(localStorage.getItem('user'));
        let activeLogin = localStorage.getItem('userActiveAccount') || user.login;

        this.state = {
            loading: false,
            dropdownActiveAccount: false,
            userAccount: {
                active: parseInt(activeLogin),
                list: user.accounts,
                info: {}
            }
        }

        this.toggleActiveAccount = this.toggleActiveAccount.bind(this);
        this.onChangeAccount = this.onChangeAccount.bind(this);
    }
    componentWillMount() {

        if (!this.props.Select)
            this.onChangeAccount(null, this.state.userAccount.active);
        else {
            this.setState({
                userAccount: {
                    list: [],
                    active: 0
                }
            });
            this.onAccountList();
        }

    }

    toggleActiveAccount() {
        this.setState(prevState => ({
            dropdownActiveAccount: !prevState.dropdownActiveAccount
        }));
    }
    onAccountList() {

        this.setState({ loading: true }, () => {

            UserService.Account.List(this.props.Status).then((response) => {

                if (response) {

                    this.setState({
                        userAccount: {
                            active: 0,
                            list: response
                        },
                        loading: false
                    });

                } else {
                    this.setState({ loading: false });
                }

            });
        });

    }
    onChangeAccount(e, login) {


        if (!this.state.loading)
            this.setState({ loading: true })

        if (this.props.List) {
            const status = this.props.Status === "deposit" ? 'deposit' : '';
            UserService.Account.List(status).then((response) => {

                if (response) {
                    this.setState({
                        userAccount: {
                            active: status === 'deposit' && !response.includes(login) ? response[0] : login,
                            list: response
                        },
                        loading: false
                    }, () => {
                        this.props.Change(null, this.state.userAccount);
                    });
                } else {
                    this.setState({ loading: false });
                }

            });


        } else {

            UserService.Account.Detail({ login: login, onlyInfo: this.props.OnlyInfo, withdrawal: this.props.Witdrawal }).then((response) => {

                if (response) {

                    this.setState({
                        userAccount: {
                            active: login,
                            list: response.accounts,
                            info: response
                        },
                        loading: false
                    }, () => {
                        this.props.Change(null, this.state.userAccount);
                    });

                    // Only Dashboard -> SetActiveAccount
                    if (this.props.Dashboard)
                        localStorage.setItem('userActiveAccount', login);

                } else {
                    this.setState({ loading: false });
                }
            });

        }

        e && e.preventDefault();
    }

    render() {

        let dropdownList = this.state.userAccount.list != null ? this.state.userAccount.list.map(item => {
            return (
                (this.props.Filter !== item) ?
                    <DropdownItem key={item} className={(this.state.userAccount.active === item ? "active" : "")} onClick={(e) => this.onChangeAccount(e, item)}>{TranslateExt("Account")} ({item}) </DropdownItem>
                    : ""
            )
        }):null;

        return (
            <LanguageConsumer>
                {() => (
                    <Fragment>
                        <Loading Show={this.state.loading} Title="Loading Content" />
                        <Dropdown isOpen={this.state.dropdownActiveAccount} toggle={this.toggleActiveAccount}>
                            <DropdownToggle className={"dropdown-toggle nav-link arrow-none waves-effect nav-user rounded " + (this.props.className || "bg-primary")} tag="a">
                                <span className="text-white header-title">
                                    {this.state.userAccount.active !== 0 ? (
                                        <Fragment>
                                            <i className="far fa-user font-18"></i> &nbsp; {Translate('Account')} ({this.state.userAccount.active}) &nbsp; <span className="mdi mdi-chevron-down"></span>
                                        </Fragment>
                                    ) : (
                                            <Fragment>
                                                <i className="far fa-user font-18"></i> &nbsp; {Translate('Select Account')} &nbsp; <span className="mdi mdi-chevron-down"></span>
                                            </Fragment>
                                        )}

                                </span>
                            </DropdownToggle>
                            <DropdownMenu>
                                {dropdownList}
                            </DropdownMenu>
                        </Dropdown>
                    </Fragment>
                )}
            </LanguageConsumer>
        )

    }

}